import React from "react";
import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  { q: "How much does junk removal cost?", a: "Starting prices range from $79 for a single bulk item up to $499+ for full eviction cleanouts. Final price depends on location, load size, material type, stairs, distance, urgency, and disposal. Send photos for an exact quote." },
  { q: "Do I need to send photos?", a: "Photos aren't required to submit a request, but they get you the fastest and firmest price. A couple photos usually replaces an on-site visit." },
  { q: "Do you offer same-day pickup?", a: "Same-day and next-day pickup are available when possible, based on crew availability in your area." },
  { q: "Do you remove appliances?", a: "Yes — refrigerators, freezers, washers, dryers, dishwashers, stoves, microwaves, water heaters, and wall A/C units." },
  { q: "Do you take construction debris?", a: "Yes — drywall, wood scrap, tile, shingles, cabinets, flooring, and general remodel or demo debris." },
  { q: "Do you remove yard debris?", a: "Yes — branches, brush, palm fronds, leaves, sod, fencing, and small stumps." },
  { q: "Do you offer dumpster rentals?", a: "Yes — 10, 20, and 30-yard roll-off dumpsters through vetted local partners. Same free-quote process." },
  { q: "What items do you not take?", a: "Paint, chemicals, gasoline, oil, asbestos, medical waste, biohazards, large amounts of tires, or hazardous waste. Extremely heavy debris (concrete, dirt, brick in bulk) is custom quote only." },
  { q: "Do I have to be home?", a: "Not always. If everything is curbside or in an accessible spot, we can pick up unattended once the price is confirmed by phone or text." },
  { q: "How do I pay?", a: "Payment methods vary by crew — we'll confirm exactly what your assigned crew accepts when we call you back with your quote. Payment is due after the job is complete, never up front." },
];

const FAQ = () => (
  <div data-testid="faq-page">
    <section className="border-b border-border bg-muted">
      <div className="container-wide py-16 lg:py-20">
        <p className="kicker">FAQ</p>
        <h1 className="mt-3 font-display text-4xl font-black sm:text-5xl lg:text-6xl">Questions, answered.</h1>
      </div>
    </section>

    <section className="section">
      <div className="container-wide max-w-3xl">
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-b border-border">
              <AccordionTrigger className="text-left font-display text-lg font-bold" data-testid={`faq-q-${i}`}>
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="mt-12 rounded-sm border border-border bg-card p-8 text-center">
          <p className="font-display text-2xl font-bold">Still have a question?</p>
          <p className="mt-2 text-muted-foreground">Call us or send a quote request — we&apos;ll get right back.</p>
          <Link to="/contact" className="btn-cta mt-6" data-testid="faq-cta">
            Contact Fast Junk Pros
          </Link>
        </div>
      </div>
    </section>
  </div>
);

export default FAQ;
